import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { History, MessageSquare } from "lucide-react";
import { CustomerCommentsTab } from "@/components/customer/CustomerCommentsTab";
import { CustomerAuditTab } from "@/components/customer/CustomerAuditTab";

// Wiederverwendbares Aktivitäts-Panel (Kommentare + Änderungsverlauf) für beliebige Entitäten.
// entityType: "customer" | "serial_number" | "service_report" | "lead"
export const ActivityPanel = ({ entityType, entityId, defaultTab = "comments", className = "" }) => {
  if (!entityId) return null;
  return (
    <div className={className} data-testid={`activity-panel-${entityType}`}>
      <Tabs defaultValue={defaultTab}>
        <TabsList className="grid grid-cols-2 w-full max-w-xs">
          <TabsTrigger value="comments" data-testid="activity-comments-tab"><MessageSquare className="w-4 h-4 mr-2" />Kommentare</TabsTrigger>
          <TabsTrigger value="history" data-testid="activity-history-tab"><History className="w-4 h-4 mr-2" />Verlauf</TabsTrigger>
        </TabsList>
        <TabsContent value="comments" className="mt-4">
          <CustomerCommentsTab entityType={entityType} entityId={entityId} />
        </TabsContent>
        <TabsContent value="history" className="mt-4">
          <CustomerAuditTab entityType={entityType} entityId={entityId} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
